// src/dashboard/reducers/index.js
import { combineReducers } from "redux";
import catalog from "./catalog";
import metrics from "./metrics";
import dashboards from "./dashboards";
import companyConfig from "./companyConfig";
import filters from "./filters";

export default combineReducers({
  catalog,
  metrics,
  dashboards,
  companyConfig,
  filters,
});
